import AssetsManagement from './AssetsManagement.vue';

export default AssetsManagement;
